import type { TimeSignature, NoteDivision } from '../types';

/**
 * 計算每小節的步數
 * @param timeSig - 拍號
 * @param noteDiv - 音符分割
 * @returns 每小節的步數
 */
export const calcStepsPerBar = (timeSig: TimeSignature, noteDiv: NoteDivision): number => {
  // 解析拍號，例如 "4/4" -> [4, 4]
  const [beats, base] = timeSig.split('/').map(Number);
  
  // 計算音符分割的倍數
  const divisionMultiplier = noteDiv === '4n' ? 1 : noteDiv === '8n' ? 2 : 4; // 16n
  
  // 根據拍號的分母和音符分割計算步數
  return (beats * 4 / base) * divisionMultiplier;
}; 